/* eslint-disable max-lines */

import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      statistics: {
         formFields: {
            healthcareFacilityUnit: {
               label: 'Jednostka organizacyjna',
               placeholder: 'Wybierz',
            },
            healthcareProviderLocation: {
               label: 'Miejsce Udzielania Świadczeń',
            },
            includeVisitsFinishedNotApproved: {
               label: 'Uwzględnij również wizyty "Niezatwierdzone"',
            },
            includeVisitsInProgress: {
               label: 'Uwzględnij również wizyty "W trakcie"',
            },
            reportingPeriod: {
               label: 'Okres sprawozdawczy',
            },
         },
         generateStatisticsButtonLabel: 'Generuj',
         generatedSuccessfully: 'Pomyślnie wygenerowano statystykę',
         menuLabel: 'Statystyki',
         modal: {
            from: 'Data od',
            submit: 'Generuj statystykę',
            title: 'Opcje statystyki',
            to: 'Data do',
            type: {
               cashReport: 'Raport kasowy',
               doctorDailyCoexistentDiagnosis: 'Rozpoznania ICD-10 - współistniejące',
               doctorDailyMainDiagnosis: 'Rozpoznania ICD-10 - główne',
               doctorDailyVisit: 'Zestawienie wizyt lekarskich i wystawionych dokumentów',
               healthcarePractitionerDailyAppointment: 'Rejestracja pacjentów',
               healthcarePractitionerSettlementDetailed: 'Raport rozliczeniowy szczegółowy',
               healthcarePractitionerSettlementGeneral: 'Raport rozliczeniowy ogólny',
               healthcareProviderDailyVisit: 'Wizyty zatwierdzone z podziałem na wiek pacjenta',
               healthcareProviderMZ15: 'Dane do raportu statystycznego MZ-15',
               healthcareProviderPatientsWithDiagnosis: 'Pacjenci z rozpoznaniem',
               healthcareProviderZD3: 'Dane do raportu statystycznego ZD-3',
            },
         },
         mz15Form: {
            failedToFetchHealthcareProviderLocations: 'Nie udało się pobrać danych Miejsc Udzielania Świadczeń.',
         },
         orderTable: {
            actions: {
               delete: 'Usuń',
               downloadAsCsv: 'Pobierz jako CSV',
               preview: 'Podgląd',
               print: 'Drukuj',
            },
            created: 'Data generowania',
            header: 'Lista utworzonych statystyk',
            name: 'Nazwa',
            noResultsLabel: 'Brak wygenerowanych statystyk',
            noResultsSubText: 'Nie wygenerowano jeszcze żadnej statystyki.',
            range: 'Zakres',
            status: 'Status',
            statusComponent: {
               FAILED: 'Niepowodzenie',
               IN_PROGRESS: 'W przygotowaniu',
               READY: 'Gotowy',
            },
         },
         preview: {
            downloadAsCsv: 'Pobierz jako CSV',
            goToStatisticsList: 'Wróć do listy statystyk',
            noResultsLabel: 'Brak danych',
            noResultsSubText: 'Brak danych spełniających podane kryteria.',
            print: 'Drukuj',
         },
         statisticsListTableNameHeader: 'Nazwa',
         zd3Form: {
            failedToFetchHealthcareFacilityUnit: 'Nie udało się pobrać danych jednostki organizacyjnej.',
         },
      },
   },
};

export const statisticsTranslationKeys = createScopedTranslationKeys(translations.pl, 'statistics');
